import "../GlobalStyles.css";
import { Button, ButtonGroup} from "reactstrap";
import { useHistory } from "react-router";
import UserHeaderComponent from "../UserHeaderComponent";
import UserChargesRegistrationForm from "./UserChargesRegistrationForm";
import { useMsal } from "@azure/msal-react";
import DriverService from "../../Services/DriverService"; 
import EmployeeService from "../../Services/EmployeeService"; 
import Driver from "../../Models/Driver";
import { useEffect, useMemo, useState } from "react";
import MoonLoader from "react-spinners/MoonLoader";
import { css } from "@emotion/react";
import ChargeRate from "../../Models/ChargeRate";

export default function UserChargesRegistrationPage(props: any){

    const history = useHistory()
    const {instance} = useMsal();

    const employeeService = useMemo(() => new EmployeeService(instance), [instance]);
    const driverService = useMemo(() => new DriverService(instance), [instance]);

    const [employeeContactId, setEmployeeContactid] = useState('')
    const [driver, setDriver] = useState<Driver>();
    const [chargeRates, setChargeRates] = useState<ChargeRate[]>([])
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() =>{
        fetchCompanyCarData();
    },[])

    async function fetchCompanyCarData(){
        try {
            const employee = await employeeService.getEmployeeByUserName();
            setEmployeeContactid(employee.contactId);
            if(!employee){
                throw new Error(`Kan geen medewerker vinden.`)
            }
            const driver = await driverService.getDriverByEmployeeContactId(employee.contactId);
            const rates = await driverService.GetAllChargeRates();

            setDriver(driver);
            setChargeRates(rates);

        } catch (error) {
            console.error("Error met bedrijfswagen data te fetchen");
            goBackToOverViewApp();

        }
    }


    function goBackToOverViewApp(): void {
        history.push("/overview");
    }

    function getLoadSpinner() {
        return (
            <MoonLoader
                color="black"
                loading={!driver || isLoading}
                css={
                    css`
                    display: block;
                    position: absolute;
                    left: calc(50% - 18px);
                    top: 125px; 
                    z-index: 1000`
                }
                size={25} />
        );
    }
 
    function getButtonDiv() {
        return (
            <>
                <ButtonGroup className="fixed-bottom navbar p-0">
                    <Button className="p-3 buttons-footer" style={{ backgroundColor: "#2F5FA1" }} onClick={() => history.push("/user-charges")}>
                        <i className="fas fa-arrow-left fa-2x"></i>
                    </Button>
                    <Button className="p-3 buttons-footer" style={{ backgroundColor: "#2F5FA1" }} onClick={() => history.push("/overview")}>
                        <i className="fas fa-home fa-2x"></i>
                    </Button>
                </ButtonGroup>
            </>
        );
    }


    function getPersonalDataDiv(){
        return (
            <div className="p-0 m-0">
                {driver &&
                        <UserChargesRegistrationForm
                        driver={driver}
                        employeeContactId={employeeContactId}
                        getCompanyCarData={fetchCompanyCarData}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        chargeRates={chargeRates} 
                        props={props}                />
                }
        
            </div>
        )
    }

    return (
        <>
            {getLoadSpinner() }
            <UserHeaderComponent headerText={"Registratie laadbeurten"} />
            
              {getPersonalDataDiv()}

            {getButtonDiv()}
        </>
      
    )
}
